import { Command, HttpMethod } from "~/extensions/api";
export class GetNyukyoshaCommand extends Command {
    constructor(nyukyokeiyakuNo) {
        super(HttpMethod.Get, `nyukyosha/admin/${nyukyokeiyakuNo}`);
    }
}
